import type React from 'react';
import PpcLink from 'app/shared/modules/hdp/PpcLink';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { StyledHdpLinksWrapper, StyledHdpPhoneIcon } from './HdpSummary.styles';
import PhoneNumberLink from 'app/shared/modules/PhoneNumberLink';
import PhoneTealOutlineFlippedIcon from 'images/icons/phone-teal-outline-flipped.svg';
import { listingUtils_shouldShowPpcLink } from 'app/shared/utils/listingUtils';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

interface HdpSummaryLinksProps {
  listing: ListingDetails;
}

const getIsShowingPhoneNumberLink = (featuredPropertyProductType?: string) => {
  const PHONE_NUMBER_ENABLED_PACKAGES = [
    'enhancedPackage',
    'premiumPackage',
    'premiumPlusPackage',
    'signaturePackage',
    'listingSpotlight',
  ];
  return featuredPropertyProductType ? PHONE_NUMBER_ENABLED_PACKAGES.includes(featuredPropertyProductType) : false;
};

const HdpSummaryLinks: React.FC<HdpSummaryLinksProps> = ({ listing }) => {
  const device = useSelector((state: RootReduxState) => state.app.device);
  const featuredPropertyProductType = listing.featuredPropertyProductType;
  const details = listing.details || {};
  const shouldShowPpcLink = listingUtils_shouldShowPpcLink(details, device);
  const isShowingPhoneNumberLink = getIsShowingPhoneNumberLink(featuredPropertyProductType);

  return shouldShowPpcLink || isShowingPhoneNumberLink ? (
    <StyledHdpLinksWrapper>
      <PpcLink listing={listing} ppcLocation="address" />
      {isShowingPhoneNumberLink && (
        <PhoneNumberLink
          listing={listing}
          phoneIcon={<StyledHdpPhoneIcon src={PhoneTealOutlineFlippedIcon} alt="" />}
        />
      )}
    </StyledHdpLinksWrapper>
  ) : null;
};

export default HdpSummaryLinks;
